var map = {
	"./aphasia/aphasia-cover-bg.png": 83,
	"./aphasia/logo.gif": 6674,
	"./favicon.ico": 858,
	"./front/img-front-2a.png": 7025,
	"./front/img-front-2b.png": 5946,
	"./front/img-front-2c.png": 1507,
	"./front/img-front-3a.png": 9018,
	"./front/img-front-3b.png": 8913,
	"./front/img-front-3c.png": 6872,
	"./icons/no-preview.png": 2089,
	"./icons/profile-generic/avatar-class.png": 5125,
	"./icons/profile-generic/avatar-example-1.png": 6505,
	"./icons/profile-generic/avatar-example-3.png": 9451,
	"./icons/profile-generic/avatar-example-5.png": 4669,
	"./icons/profile-generic/avatar-example-8.png": 4968,
	"./icons/profile-generic/profile-full.jpg": 3818,
	"./icons/profile-generic/profile-icon.jpg": 4374,
	"./icons/profile-generic/profile-large.jpg": 7708,
	"./icons/profile-generic/profile-master.jpg": 7439,
	"./icons/profile-generic/profile-medium.jpg": 3544,
	"./icons/profile-generic/profile-small.jpg": 4888,
	"./icons/profile-generic/profile-thumb.jpg": 4353,
	"./icons/profile-generic/profile-tiny.jpg": 8291,
	"./icons/resource-generic/file-large.png": 8492,
	"./icons/resource-generic/file-master.png": 7291,
	"./icons/resource-generic/file-medium.png": 9160,
	"./icons/resource-generic/file-small.png": 3360,
	"./icons/resource-generic/file-thumb.png": 2541,
	"./icons/resource-generic/file-tiny.png": 4015,
	"./layout/bg-header.jpg": 7936,
	"./layout/bg-sticky.png": 7570,
	"./layout/bg-upload.png": 8888,
	"./layout/bg_404-page.jpg": 753,
	"./layout/bg_404-text.png": 7401,
	"./layout/bg_500-text.png": 5338,
	"./layout/bg_body.jpg": 9453,
	"./layout/body-bg-toast-dark.png": 4510,
	"./layout/body-bg-toast.png": 3907,
	"./layout/favicon.ico": 55,
	"./layout/header-bg-dark.png": 2727,
	"./layout/icon-left-right.png": 699,
	"./layout/icon-null-circle.png": 8521,
	"./layout/img-feature-bg-3.png": 1889,
	"./layout/img-front-bg.jpg": 1952,
	"./layout/img-wizard-break.png": 7024,
	"./layout/logo_header.png": 9910,
	"./layout/ontario-logo-partnership-footer.svg": 9459,
	"./layout/p-network-logo.png": 3266,
	"./layout/post-bg.jpg": 2887,
	"./layout/sample-profile.jpg": 6307,
	"./lib/content-tools/ce-drop-above.png": 2346,
	"./lib/content-tools/ce-drop-below.png": 974,
	"./lib/content-tools/ce-drop-left.png": 726,
	"./lib/content-tools/ce-drop-right.png": 971,
	"./lib/content-tools/video.png": 6601,
	"./lib/select2-spinner.gif": 7757,
	"./lib/select2.png": 1710,
	"./lib/select2x2.png": 9580,
	"./maple/slider1.jpg": 2946,
	"./maple/slider2.jpg": 5226,
	"./maple/slider3.jpg": 1712,
	"./maple/slider4.jpg": 8195,
	"./post-bg/post-bg-1.jpg": 5535,
	"./post-bg/post-bg-2.jpg": 1920,
	"./post-bg/post-bg-5.jpg": 4755,
	"./post-bg/post-bg.jpg": 941,
	"./tour/1_Tour_1.jpg": 7787,
	"./tour/1_Tour_2.png": 136,
	"./tour/1_Tour_3.png": 4001,
	"./tour/1_Tour_4.png": 7262,
	"./tour/1a_Tour_5.png": 2626,
	"./tour/1b_Tour_5.png": 3735,
	"./tour/2_Tour_1.png": 150,
	"./tour/2_Tour_2.png": 4125,
	"./tour/2_Tour_3.png": 228,
	"./tour/2_Tour_4.png": 4091,
	"./tour/2_Tour_5.png": 9266,
	"./tour/3_Tour_1.jpg": 7265,
	"./tour/3_Tour_2.png": 3330,
	"./tour/3_Tour_3.png": 4459,
	"./tour/3_Tour_4.png": 8548,
	"./tour/3_Tour_5.png": 9677,
	"./tour/4_Tour_1.jpg": 9528,
	"./tour/4_Tour_2.png": 1927,
	"./tour/4a_Tour_3.png": 8321,
	"./tour/4a_Tour_4.png": 2206,
	"./tour/4a_Tour_5.png": 9895,
	"./tour/4b_Tour_3.png": 5028,
	"./tour/4b_Tour_4.png": 4971,
	"./tour/4b_Tour_5.png": 5970,
	"./tour/5_Tour_1.png": 6295,
	"./tour/5_Tour_2.png": 7820,
	"./tour/5_Tour_5.png": 7987,
	"./tour/5a_Tour_3.png": 3472,
	"./tour/5a_Tour_4.png": 4799,
	"./tour/5b_Tour_3.png": 2557,
	"./tour/5b_Tour_4.png": 994,
	"./tour/5c_Tour_3.png": 8982,
	"./tour/6a_Tour_4.png": 2512,
	"./tour/6b_Tour_4.png": 1729,
	"./tour/7_Tour_4.png": 8864,
	"./tour/8a_Tour_4.png": 6594,
	"./tour/8b_Tour_4.png": 1439,
	"./tour/binder_content.jpg": 3843,
	"./tour/class_post.jpg": 4572,
	"./tour/full_daybook.jpg": 1382,
	"./tour/group_post.jpg": 5627,
	"./tour/welcome_main.jpg": 9085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2672;